import { Component, OnInit, Inject } from '@angular/core';
import { AddSessionComponent, MyErrorStateMatcher } from '../add-session/add-session.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AgendaService } from 'src/app/services/agenda.service';
import { AgendaGenerator } from 'src/app/entities/agendaGenerator';
import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'app-gen-agenda',
  templateUrl: './gen-agenda.component.html',
  styleUrls: ['./gen-agenda.component.css']
})
export class GenAgendaComponent implements OnInit {

  constructor(private agendaService: AgendaService,
              private  dialogRef: MatDialogRef<AddSessionComponent>,
              private toastr: ToastrService,
              @Inject(MAT_DIALOG_DATA) public data: AddSessionComponent) { }

  selectedValue: string;
  algoritmos: Algoritmo[] = [
    {value: 'maxVotes', viewValue: 'por Votos'},
    {value: 'intentionVotes', viewValue: 'por Intención'}
  ];

  agendaGenerator: AgendaGenerator = new AgendaGenerator();
  agendaId: number = this.data.agendaId;
  matcher = new MyErrorStateMatcher();
  sesiones = new FormControl('', [Validators.required, ]);
  tracks = new FormControl('', [Validators.required, ]);
  algoritmo = new FormControl('', Validators.required);
  formGroup = new FormGroup({ sesiones: this.sesiones, tracks: this.tracks});


  ngOnInit(): void {
  }


  onSubmit(){
    this.matcher.submited = true;
    this.transformToAgendaGenerator();
    this.generateAgenda();
  }

  generateAgenda(){
    this.agendaService.generateAgenda(this.agendaGenerator)
      .subscribe(
        (dataSaved) => {
          this.toastr.success('Agenda generada');
          this.onClose();
        },
        (error) => {
          console.error(error);
        }
      );
  }

  transformToAgendaGenerator(){
    this.agendaGenerator.agenda = this.agendaId;
    this.agendaGenerator.sesiones = this.formGroup.get('sesiones').value;
    this.agendaGenerator.tracks = this.formGroup.get('tracks').value;
    this.agendaGenerator.algoritmo = this.selectedValue;
  }

  onClose() {
    this.dialogRef.close();
  }
}

interface Algoritmo {
  value: string;
  viewValue: string;
}


